import DuckEntity from './DuckEntity';

const stripeBalanceTransactions = new DuckEntity('stripeBalanceTransactions');

export default stripeBalanceTransactions.reducer;

export { stripeBalanceTransactions };
